module.exports = __webpack_public_path__ + "static/media/Jane_removebg.8394688b.svg";